import { render, staticRenderFns } from "./GuideModuleLoader.vue?vue&type=template&id=3bcda938&scoped=true"
import script from "./GuideModuleLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideModuleLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuideModuleLoader.vue?vue&type=style&index=0&id=3bcda938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcda938",
  null
  
)

export default component.exports